import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { FiPlus, FiMinus } from 'react-icons/fi';
import './QAAccordion.css';
import TitleSubtitle from "../titlesubtitle/TitleSubtitle";
import { FaQuestionCircle } from "react-icons/fa";
import { Tooltip } from "@mui/material";

function QAAccordion() {
    const [activeIndex, setActiveIndex] = useState(null);
    const [faqData, setFaqData] = useState([]);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllFAQ`)
            .then(response => {
                if (response.data && response.data.success) {
                    setFaqData(response.data.data);
                }
            })
            .catch(error => console.log(error));
    }, []);

    const toggleAccordion = (index) => {
        const newIndex = activeIndex === index ? null : index;
        setActiveIndex(newIndex);

    };


    return (
        <div className="qa-page">
            <div className="qa-main-container">
                <Tooltip title={t("ხშირად დასმული კითხვები")}>
                    <div className="qa-icon">
                        <FaQuestionCircle />
                    </div>
                </Tooltip>
                <TitleSubtitle
                    titleText={t("ხშირად დასმული კითხვები")}
                    subtitleText={
                        <>
                            {t("ტექნიკური და სამშენებლო")} <br />
                            {t("ზედამხედველობის სააგენტო")}
                        </>
                    }
                />
                <div className="qa-accordion-container">
                    {faqData.map((qa, index) => (
                        <div
                            key={qa.id}

                            className={`qa-accordion-item ${activeIndex === index ? 'qa-accordion-active' : ''}`}
                        >
                            <div onClick={() => toggleAccordion(index)} className="qa-accordion-header">
                                <div className="qa-accordion-question">
                                    {i18n.language === 'geo' ? qa.title : qa.titleEng}
                                </div>
                                <div className={`qa-accordion-icon ${activeIndex === index ? 'qa-accordion-icon-open' : ''}`}>
                                    {activeIndex === index ? <FiMinus /> : <FiPlus />}
                                </div>
                            </div>
                            {activeIndex === index && (
                                <div
                                    className="qa-accordion-answer"
                                    dangerouslySetInnerHTML={{
                                        __html: i18n.language === 'geo' ? qa.description : qa.descriptionEng,
                                    }}
                                />
                            )}

                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default QAAccordion;
